function isStripeProvider(provider: string | null, paymentProvider?: string | null): boolean {
  return provider === 'stripe' || paymentProvider === 'stripe';
}

export default function ProviderBadge({
  provider,
  paymentProvider,
}: {
  provider: string | null;
  paymentProvider?: string | null;
}) {
  if (isStripeProvider(provider, paymentProvider)) {
    return (
      <span className="inline-block font-mono text-[10px] uppercase tracking-widest px-2 py-0.5 rounded border text-sky-300 bg-sky-500/10 border-sky-500/20">
        Card
      </span>
    );
  }

  if (provider === 'moonpay_commerce' || provider === 'moonpay') {
    return (
      <span className="inline-block font-mono text-[10px] uppercase tracking-widest px-2 py-0.5 rounded border text-emerald-400 bg-emerald-500/10 border-emerald-500/20">
        USDC
      </span>
    );
  }

  if (provider) {
    return (
      <span
        className="inline-block font-mono text-[10px] uppercase tracking-widest px-2 py-0.5 rounded"
        style={{
          color: 'var(--dash-text-muted)',
          background: 'var(--dash-hover-bg)',
          border: '1px solid var(--dash-border)',
        }}
      >
        {provider}
      </span>
    );
  }

  return <span className="font-mono text-xs" style={{ color: 'var(--dash-text-faint)' }}>--</span>;
}

export { isStripeProvider };
